// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const logo = "ProviderBadge__logo__WOVBc";
export const medium = "500";
export const providerBadge = "ProviderBadge__providerBadge__c5f9g";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";